import { WebPlugin } from "@capacitor/core";
export class CapacitorNativeGoogleAuthWeb extends WebPlugin {
    async signIn() {
        throw this.unimplemented("Google Sign-in is not supported on web by this plugin.");
    }
}
//# sourceMappingURL=web.js.map